import * as React from 'react'
const CheckmarkChecked = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm5.936 9.686a1.5 1.5 0 0 0-2.122-2.122l-5.689 5.69-1.94-1.94a1.5 1.5 0 0 0-2.12 2.122l3 3a1.5 1.5 0 0 0 2.12 0l6.75-6.75Z"
      clipRule="evenodd"
    />
  </svg>
)
export default CheckmarkChecked
